import { createContext } from 'react';
import { IReportsDashboardConfig } from '~/src/dash/views/ias-publisher/IASReportsDashboard/ReportsDashboard/common/types';

interface IReportsDashboardContext {
  cfg: IReportsDashboardConfig;
}

export const ReportsDashboardContext = createContext({} as IReportsDashboardContext);
